import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReservationService } from '@app/_components/reservation';
import { TaskService } from '@app/_components/task';
import { AlertService } from '@app/_services';

@Component({
    selector: 'app-task-reservation-select',
    template: `
<form [formGroup]="reservationSelectForm">
  <p-autoComplete
      [suggestions]="reservationSuggestions"
      [multiple]="false"
      [forceSelection]="false"
      [dropdown]="false"
      [style]="{'width':'100%'}"
      [inputStyle]="{'width':'100%'}"
      [minLength]="2"
      formControlName="reservation"
	  appendTo="body"
      unique="true"
      optionLabel="summary"
      placeholder="Reservation"
      (onSelect)="onSelect($event)"
      (onUnselect)="onUnselect($event)"
      (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
      </p-autoComplete>
  </form>
`,
    styles: [],
    standalone: false
})
export class TaskReservationSelectComponent implements OnInit, OnChanges {
	reservationSuggestions: string[];
	reservationSelectForm: UntypedFormGroup;
	taskId: number;

	@Output() messageEvent = new EventEmitter<string>();

	@Input() taskApi: any;






	constructor(
		private formBuilder: UntypedFormBuilder,
		private taskService: TaskService,
		private reservationService: ReservationService,
		private alertService: AlertService) { }

	ngOnInit() {

		if (!this.taskId && this.taskApi) { this.taskId = this.taskApi.taskId; }

		const initial = this.normalizeReservation(this.taskApi?.reservation);
		this.reservationSelectForm = this.formBuilder.group({
			reservation: [initial],
			taskId: [this.taskId]
		});
	}

	// for each letter typed in autocomplete...
	onKeyInput(event) {
		let query = event.query;
		this.findReservationsWith(query);
		return this.reservationSuggestions;
	}

	// not used.
	onKeyUp(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			let tokenInput = event.srcElement as any;
			console.log('tokenInput ' + JSON.stringify(tokenInput.value));
			if (tokenInput.value) {
				this.reservationSuggestions.push(tokenInput.value);
				tokenInput.value = '';
			}
		}
	}

	onSelect(event: any) {
		if (this.taskId == null) {
			this.alertService.error('Please enter a task name first');
		}
		else {
			const r = event?.value ?? event;
			let data: any = {};
			data.taskId = this.taskId;
			data.reservationId = r.reservationId;
			data.shortTermRentalId = r.shortTermRentalId;
			this.messageEvent.emit(data);
			this.addTaskReservation(data);
		}
	}


	onUnselect(event: any) {
		const r = event?.value ?? event;
		let data: any = {};
		data.taskId = this.taskId;
		data.reservationId = r?.reservationId;
		this.deleteTaskReservation(data);
	}

	findReservationsWith(queryString: string) {
		this.reservationService.findReservationsWith(queryString).pipe(first()).subscribe(

			data => {
				console.log('reservation serach: ' + JSON.stringify(data));
				this.reservationSuggestions = [];
				this.reservationSuggestions = data.data.reservationSummaryList;
				// console.log('QA: ' + JSON.stringify(this.reservationSuggestions));
			},
			error => {
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() => { }
		);
	}

	addTaskReservation(reservation) {
		this.taskService.updateTaskReservation(reservation).pipe(first()).subscribe(

			data => {
				// console.log('reservations are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error => {
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() => { }
		);
	}

	deleteTaskReservation(reservation) {
		this.taskService.deleteTaskReservation(reservation).pipe(first()).subscribe(

			data => {
				// console.log('reservations are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error => {
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() => { }
		);
	}

	/**
	  *
	  * method to update parent component
	  */


	ngOnChanges() {
		if (this.reservationSelectForm === undefined || !this.taskApi) {
			return;
		}
		this.taskId = this.taskApi.taskId;
		this.reservationSelectForm.patchValue({
			taskId: this.taskApi.taskId,
			reservation: this.normalizeReservation(this.taskApi.reservation),
		});
	}

	/** Single object + summary string for PrimeNG (task API reservation often omits summary). */
	private normalizeReservation(r: any): any | null {
		if (!r || typeof r !== 'object') {
			return null;
		}
		const out = { ...r };
		if (typeof out.summary === 'string' && out.summary.trim()) {
			return out;
		}
		out.summary = TaskReservationSelectComponent.buildReservationSummary(out);
		return out;
	}

	private static buildReservationSummary(r: any): string {
		const pc = r.shortTermRental?.propertyCode ?? r.propertyCode ?? '';
		const ln = (r.guestProfile?.lastName ?? r.lastName ?? '').toString();
		const lnU = ln ? ln.toUpperCase() : '';
		const cin = (r.checkInDate ?? r.checkInDateTime ?? '').toString().slice(0, 10);
		const cout = (r.checkOutDate ?? r.checkOutDateTime ?? '').toString().slice(0, 10);
		const parts = [pc, lnU, cin, cout].filter(Boolean);
		if (parts.length) {
			return parts.join(' ');
		}
		return r.reservationId != null ? `Reservation #${r.reservationId}` : '';
	}
}
